<template>
  <div>
    <div v-if="indentlevel===0" class="row treeheader">
      <div class="col-6 tabletitle" v-html="ttitle">

      </div>
      <div class="col-6 text-right">
        <span class="ib ml-1" v-for="burger in burgermenu" v-if="burgermenu.length>0">
          <span v-if="burger.length>1">
            <b-form-select class="burger ib" v-model="burgerselect" @change="doBurgerChange" :options="burger"></b-form-select>
          </span>
          <span v-if="burger.length===1">
            <button class="burgerbtn btn-secondary" @click="doBurgerClick(burger[0].value)">{{burger[0].html}}</button>
          </span>
        </span>
      </div>
    </div>
    <div v-if="thisdata!==null&&thisdata.length>0&&indentclass!==null" v-for="item in thisdata" class="row">
      <div class="col-12">
        <div v-bind:class="indentclass">
          <div class="row bg-white pp5 rounded mb-3 shadow">
            <div class="col-9">
              <div>
                <router-link :to="item.Address" v-html="item.Name"></router-link>&nbsp;&nbsp;
                <span v-html="item.Additional"></span>
              </div>
            </div>
            <div class="col-3 text-right">
              <span v-for="linkdata in item.Links" class="ib ml-3">
                <router-link :to="linkdata.Address"><font-awesome-icon :icon="linkdata.Icon" aria-label="linkdata.Label"></font-awesome-icon></router-link>
              </span>
              <span class="ib ml-3" v-show="isadmin===true">
                <button class="btn-transparent" @click="doDelete(item.GroupID,item.ParentID)"><font-awesome-icon icon="times"></font-awesome-icon></button>
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div v-if="item.Children.length>0">
              <wondertree :title="title" :thisdata="item.Children" :indentlevel="nextindent" :burgermenu="burgermenu" :methods="methods" :nomessage="nomessage"
                          :isadmin="isadmin" :poolid="poolid"></wondertree>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="thisdata!==null&&thisdata.length===0" class="bg-white pp5 rounded mb-3 shadow">
      {{nomessage}}
    </div>

  </div>
</template>

<style scoped>
  .burger {
    width: 100%;
    margin: 0;
    height: 35px;
    padding: 0px 0px 0px 25px;
  }

  .treeheader {
    border-bottom: 1px solid #666;
    padding-bottom: 5px;
    margin-bottom: 15px;
  }
</style>

<script>
  export default {
    name: "WonderTree",
    props: ["burgermenu", "title", "thisdata", "indentlevel", "methods", "nomessage", "isadmin", "poolid"],
    data() {
      return {
        burgerselect: null,
        indentclass: null,
        nextindent: null,
        ttitle: null
      }
    },
    methods: {
      doBurgerChange() {
        if (this.burgerselect !== null) {
          var method = this.methods[this.burgerselect];
          this.burgerselect = null;
          this.doMethod(method.method, null, method.ref);
        }
      },
      doBurgerClick(m) {
        var method = this.methods[m];
        this.doMethod(method.method, null, method.ref);
      },
      doDelete(grpid, parid) {
        this.$bvModal.msgBoxConfirm('Are you sure you wish to delete this group permanently? All subgroups will be deleted also and this action cannot be undone!', {
          title: 'Confirm Delete',
          size: 'sm',
          id: "group_delete_confirm",
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }).then(value => {
          if (value) {
            this.apiCommand([
              {
                Operation: "LicensePool",
                Function: "DeleteGroup",
                Fields: {
                  LicensePoolGroupID: grpid,
                  LicensePoolID: this.poolid,
                  ParentID: parid
                }
              }
            ]).then(r => {
              this.popDialog(0, "Group Deleted Successfully");
              this.$parent.renderTree();
            });
          }
        });

        Window.loadLanguageContent();
      },
      doMethod(tmeth, tparam, tref) {
        tmeth(tparam, tref);
      },
      renderTree() {
        this.$parent.renderTree();
      },
      update() {
        this.ttitle = "<span id=\"tableTitle\">" + this.title + "</span> (" + (this.thisdata.length + 1) + " <span id='table_top_level_items'>Top-Level Items</span>)";
        this.$forceUpdate();
      }
    },
    mounted() {
      this.ttitle = "<span id=\"tableTitle\">" + this.title + "</span> (" + this.thisdata.length + " <span id='table_top_level_items'>Top-Level Items</span>)";
      this.nextindent = this.indentlevel + 1;
      this.indentclass = "i" + this.indentlevel;
    }
  }
</script>
